import {AVAILABLE_OR_NOT, FACILITY_CATEGORY, RESERVATION_ACCEPTABILITY_FOR_RESIDENT} from '../../CodeMaster'
import {ImageLocation} from './FacilityDetails'
import {Nullable} from '../../app/TypeHelpers'

export default class FacilityCardInfo {
    facilityId: number
    category: FACILITY_CATEGORY
    facilityName: string
    image: Nullable<ImageLocation>
    stayAvailability: AVAILABLE_OR_NOT
    residentReserve: RESERVATION_ACCEPTABILITY_FOR_RESIDENT

    constructor(facilityId: number,
                category: FACILITY_CATEGORY,
                facilityName: string,
                image: ImageLocation | null,
                stayAvailability: AVAILABLE_OR_NOT,
                residentReserve: RESERVATION_ACCEPTABILITY_FOR_RESIDENT,
    ) {
        this.facilityId = facilityId
        this.category = category
        this.facilityName = facilityName
        this.image = image
        this.stayAvailability = stayAvailability
        this.residentReserve = residentReserve
    }

    static from(json: any): FacilityCardInfo {
        return new FacilityCardInfo(
            json.facilityId,
            FACILITY_CATEGORY.codeToEnumConstants(json.category),
            json.facilityName,
            json.image,
            AVAILABLE_OR_NOT.codeToEnumConstants(json.stayAvailability),
            RESERVATION_ACCEPTABILITY_FOR_RESIDENT.codeToEnumConstants(json.residentReserve),
        )
    }
}
